import { z } from 'zod';

/** requireMessage=false면 제목/본문을 안 쓰는 템플릿용 — 필수 검증만 스킵(필드 자체는 유지). */
export function createSendFormSchema(requireMessage: boolean, requireExpiresAt = true) {
  return z.object({
    expiresAt: requireExpiresAt ? z.string().min(1, '링크 유효기간을 선택해 주세요.') : z.string(),
    title: requireMessage
      ? z.string().min(1, '제목을 입력해 주세요.').max(40, '제목은 40자 이하입니다.')
      : z.string().max(40, '제목은 40자 이하입니다.'),
    content: requireMessage
      ? z.string().min(1, '내용을 입력해 주세요.').max(300, '내용은 300자 이하입니다.')
      : z.string().max(300, '내용은 300자 이하입니다.'),
    // 고객 쪽(좌) 메시지 — 표시 · 입력만, 알림톡 발송에 쓰지 않으므로 필수 아님(고객은 [공유하기]로 링크 전달)
    customerTitle: z.string().max(40, '제목은 40자 이하입니다.').optional(),
    customerContent: z.string().max(300, '내용은 300자 이하입니다.').optional(),
  });
}

export type SendFormValues = z.infer<ReturnType<typeof createSendFormSchema>>;
